import { render, staticRenderFns } from "./InputColor.vue?vue&type=template&id=29b30554&"
import script from "./InputColor.vue?vue&type=script&lang=ts&"
export * from "./InputColor.vue?vue&type=script&lang=ts&"
import style0 from "./InputColor.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports